import Rails from "@rails/ujs"

Rails.start();
import "./controllers"
import "@hotwired/turbo-rails"
import "@hotwired/stimulus"

// Chartkick with Chart.js adapter for data visualization
import "chartkick/chart.js"

// Charts export functionality
import "./charts_export"
import "./performance_chart"

Turbo.session.drive = false
